export default {
  data() {
    return {
      graphByList: [
        {
          value: 'number',
          text: 'Número',
        },
        {
          value: 'percentage',
          text: 'Porcentaje',
        },
      ],
      channelsList: [
        {
          value: '',
          text: 'Canal',
        },
        {
          value: 1,
          text: 'Llamada',
        },
        {
          value: 2,
          text: 'IVR',
        },
        {
          value: 3,
          text: 'SMS',
        },
        {
          value: 4,
          text: 'Email',
        },
        {
          value: 10,
          text: 'Otro',
        },
      ],
      trMorasList: [
        {
          value: '',
          text: 'Tramo de mora',
        },
        {
          value: 0,
          text: 'Al día',
        },
        {
          value: 1,
          text: '1 - 30 días',
        },
        {
          value: 2,
          text: '31 - 60 días',
        },
        {
          value: 3,
          text: '61 - 90 días',
        },
        {
          value: 4,
          text: '91 - 120 días',
        },
        {
          value: 5,
          text: '121 - 150 días',
        },
        {
          value: 6,
          text: '151 - 180 días',
        },
      ],
      pursesList: [
        {
          value: '',
          text: 'Cartera',
        },
        {
          value: 'Normal',
          text: 'Normal',
        },
        {
          value: 'Refinanciado',
          text: 'Refinanciado',
        },
        {
          value: 'Repactado',
          text: 'Repactado',
        },
        {
          value: 'Avance',
          text: 'Avance',
        },
        {
          value: 'Cuota Chica',
          text: 'Cuota Chica',
        },
        {
          value: 'Repactado',
          text: 'Repactado',
        },
      ],
      managersList: [
        {
          value: '',
          text: 'Gestor',
        },
      ],
    };
  },
};



// WEBPACK FOOTER //
// ./src/mixins/reportsList.js